<template>
  <section v-if="offers?.length" :id="data?.anchor_id ? data.anchor_id : null" class="accommodationOffer defaultSectionPaddings defaultSectionMargins" :class="{'singleOffer': offers.length === 1}">
    <div class="container">
      <h2 v-html="data.title" />

      <FlickitySlider class="accommodationOffer__Slider" :options="flickityOptions">
        <div v-for="item in offers" class="accommodationOffer__Item">
          <div class="accommodationOffer__ImagesWrapper">
            <FlarePicture
              class="accommodationOffer__MainImage"
              :src="{
                1920: { src: item.image, width: 550, height: 355, size: 'both', crop: 'fill' },
              }"
              :alt="item.image"
            />
            <Flare v-if="item.image_discount" class="accommodationOffer__DiscountImage" :srcset="item.image_discount" width="250" :alt="item.image_discount" />
          </div>
          <div class="accommodationOffer__Content">
            <div class="accommodationOffer__Dates">{{ formatDate(item.travel_date_from) }} - {{ formatDate(item.travel_date_to) }}</div>

            <div>
              <h3 v-text="item.title" />
              <p v-text="item.subtitle" />
            </div>
          </div>
          <nuxt-link :to="item.sef">{{ item.title }}</nuxt-link>
        </div>
      </FlickitySlider>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {}
  })

  const { page } = usePage();
  const offers = ref([]);

  async function getOffers() {
    if (!page.value.id) return;
    try {
      const response = await useServerFetch('offer/', {
        params: {
          accommodation: page.value.id,
        }
      })
  
      if (response?.results) offers.value = response.results;
    } catch(error) {
      console.error(error)
    }
  }

  await getOffers();

  const flickityOptions = {
    pageDots: false,
    prevNextButtons: false,
    contain: true,
    cellAlign: 'left',
  };
</script>

<style lang="scss">
  // @import url('@/assets/styles/components/blocks/_accommodationOffers.scss');
</style>